<template>
    <!-- 数据表格 -->
    <el-card class="table-card" shadow="never">
        <el-button type="primary" @click="addRechargeItem">新增</el-button>
        <div class="table-wrapper">
            <el-table :data="rows" v-loading="loading" style="width: 100%">
                <el-table-column label="实际支付金" prop="discount" width="100" />
                <el-table-column label="原价" prop="amount" width="100">
                    <template #default="scope">
                        <el-text class="mx-1" tag="del">{{ scope.row.amount }}</el-text>
                    </template>
                </el-table-column>
                <el-table-column label="可获积分" prop="point" width="100" />
                <el-table-column label="排序" prop="sort" width="100" />
                <el-table-column label="操作" width="120" align="center">
                    <template #default="scope">
                        <el-link underline="always" type="primary" @click="editRechargeItem(scope.row)">{{
                            "编辑"
                            }}</el-link>
                        <el-divider direction="vertical" />
                        <el-link underline="always" type="danger" @click="deleteRechargeItem(scope.row.id)">{{
                            "删除"
                            }}</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-dialog v-model="newRechargeItemParams.showDialog" :title="newRechargeItemParams.id ? '修改充值项目' : '新增充值项目'"
            width="600px">
            <el-form :model="newRechargeItemParams" label-width="100px">
                <el-form-item label="实际支付金" prop="discount" required>
                    <el-input-number v-model="newRechargeItemParams.discount" />
                </el-form-item>
                <el-form-item label="原价" prop="amount" required>
                    <el-input-number v-model="newRechargeItemParams.amount" />
                </el-form-item>
                <el-form-item label="可获积分" prop="point" required>
                    <el-input-number v-model="newRechargeItemParams.point" />
                </el-form-item>
                <el-form-item label="排序值" prop="sort" required>
                    <el-input-number v-model="newRechargeItemParams.sort" />
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="newRechargeItemParams.showDialog = false">取消</el-button>
                <el-button v-loading="newRechargeItemParams.loading" type="primary" @click="submit">确定</el-button>
            </template>
        </el-dialog>
    </el-card>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { ElMessage } from 'element-plus';
import { apiCall } from "@/utils/api";

const loading = ref(false);
const rows = ref([]);

const newRechargeItemParams = reactive({
    showDialog: false,
    id: "",
    amount: 0,
    discount: 0,
    point: 0,
    sort: 10,
    loading: false,
});

async function loadData() {
    loading.value = true;

    const response = await apiCall("recharge.getAllItems", {});
    if (!response) {
        return false;
    }
    rows.value = response;

    loading.value = false;
}

function addRechargeItem() {
    newRechargeItemParams.id = "";
    newRechargeItemParams.amount = 0;
    newRechargeItemParams.discount = 0;
    newRechargeItemParams.point = 0;
    newRechargeItemParams.sort = 10;
    newRechargeItemParams.showDialog = true;
}

function editRechargeItem(row) {
    newRechargeItemParams.id = row.id;
    newRechargeItemParams.amount = row.amount;
    newRechargeItemParams.discount = row.discount;
    newRechargeItemParams.point = row.point;
    newRechargeItemParams.sort = row.sort;
    newRechargeItemParams.showDialog = true;
}

async function submit() {
    let success = false;
    if (!newRechargeItemParams.id) {
        success = await submitAddRechargeItem();
    } else {
        success = await submitEditRechargeItem();
    }

    if (success) {
        newRechargeItemParams.id = "";
        newRechargeItemParams.amount = 0;
        newRechargeItemParams.discount = 0;
        newRechargeItemParams.point = 0;
        newRechargeItemParams.sort = 10;
        newRechargeItemParams.showDialog = false;
        await loadData();
    }
}

async function submitAddRechargeItem() {
    newRechargeItemParams.loading = true;

    const response = await apiCall("recharge.add", {
        amount: newRechargeItemParams.amount,
        discount: newRechargeItemParams.discount,
        point: newRechargeItemParams.point,
        sort: newRechargeItemParams.sort,
    });

    newRechargeItemParams.loading = false;
    if (!response) {
        return false;
    }
    ElMessage.success('增加充值项目成功');
    return true;
}

async function submitEditRechargeItem() {
    newRechargeItemParams.loading = true;

    const response = await apiCall("recharge.modify", {
        id: newRechargeItemParams.id,
        amount: newRechargeItemParams.amount,
        discount: newRechargeItemParams.discount,
        point: newRechargeItemParams.point,
        sort: newRechargeItemParams.sort,
    });

    newRechargeItemParams.loading = false;
    if (!response) {
        return false;
    }
    ElMessage.success('修改充值项目成功');
    return true;
}

async function deleteRechargeItem(id) {
    loading.value = true;

    const response = await apiCall("recharge.del", {
        id,
    });

    loading.value = false;
    if (!response) {
        return false;
    }
    ElMessage.success('删除充值项目成功');
    await loadData();
}

onMounted(async () => {
    await loadData();
});
</script>

<style scoped></style>
